import {
  _getGUID,
  _initalizeClientPublicKey,
  _setDHRefreshLocalItems,
  deviceType,
  versionNumber,
  _getDeviceInfo,
  _getUserInfo,
  _getAccessToken,
  _getClientPublicKey,
  language,
} from "network-helper";

import {_getRequestTokenResponse} from './Network/JHHLogin.js';
 
export const _setRequestToken = async (dataObj, url) => {
  try {
    const data={
      "public_key":_initalizeClientPublicKey(),
      "device_type":deviceType,
      "version_number":versionNumber,
      ...dataObj
    }
    
    const response = await _getRequestTokenResponse(data, url);
    if (response && response.token && response.public_key && response.ttl) {
      _setDHRefreshLocalItems(response);
    }
    return response;
  } catch (err) {
    throw err;
  }
};